import { render, staticRenderFns } from "./EstimatedComputeCost.vue?vue&type=template&id=2c90e482&scoped=true"
import script from "./EstimatedComputeCost.vue?vue&type=script&lang=js"
export * from "./EstimatedComputeCost.vue?vue&type=script&lang=js"
import style0 from "./EstimatedComputeCost.vue?vue&type=style&index=0&id=2c90e482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90e482",
  null
  
)

export default component.exports